import gql from 'graphql-tag';

export const UPDATE_ROW_DISPLAY_STATUS = gql`
  mutation UpdateVendorOpportunity($fieldsObj: UpdateVendorOpportunityInput!, $VOId: String!) {
    updateVendorOpportunity(fieldsObj: $fieldsObj, VOId: $VOId)
  }
`;
